// extracted by mini-css-extract-plugin
export var previewContainer = "_sr-0";